
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':site.isMigrationActive}">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter site details:</p>
      </div>
    </div>
  </div>
  <form #siteForm="ngForm">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="required" for="name">Name:</label>
            <input class="form-control" id="name" type="text" [(ngModel)]="site.name" name="siteName" required maxlength="100">
          </div>
          <div class="form-group col-lg-6">
            <label for="siteCode">Site Code:</label>
            <input class="form-control" id="siteCode" type="text" [(ngModel)]="site.siteCode" name="siteCode" maxlength="40">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6" *ngIf="site.siteNameStructure">
            <div class="inline-block">
              <label>Site Name Structure:</label>
            </div>
            <div class="inline-block"><span>{{ site.siteNameStructure }}</span></div>
          </div>
          <div class="form-group col-lg-6" *ngIf="isLegacy">
            <label class="required" for="k2Name">K2/ACDC Site Name:</label>
            <div class="input-group">
              <input class="form-control" id="k2Name" type="text" [(ngModel)]="site.k2Name" name="k2Name" required maxlength="100"><span class="input-group-append">
                <button class="btn btn-primary" (click)="setK2siteName()" [disabled]="!k2Sites.length">Search</button></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col mb-3"><span>CDF Data: <a href="javascript:void(0)" (click)="editCdf()"><span class="oi oi-plus oi-smaller"></span> Add CDF</a></span>
            <div class="row" *ngFor="let cdf of site.cdfs">
              <div class="col-12" *ngIf="cdf.id">{{ cdf.id }} ({{ cdf.system }}) <a href="javascript:void(0)" (click)="editCdf(cdf)"><span class="oi oi-pencil oi-smaller"></span> Edit</a>
                <ul class="ml-2" *ngIf="cdf.buildings?.length">
                  <li *ngFor="let building of cdf.buildings">{{ building }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="startDate">Estimated Start Date:
                <help-dialog-button fieldName="Estimated Start Date" helpString="The estimated date that deployment deliverables will begin for this site"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="startDate" [(ngModel)]="site.estimatedStartDate" name="estimatedStartDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedStartDate" name="estimatedStartDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="completeDate">Estimated Completion Date:
                <help-dialog-button fieldName="Estimated Completion Date" helpString="The estimated date that all deployment deliverables will be completed for this site"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="completeDate" [(ngModel)]="site.estimatedCompleteDate" name="estimatedCompleteDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedCompleteDate" name="estimatedCompleteDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="approvedDate">Approved Date:
                <help-dialog-button fieldName="Approved Date" helpString="The date that indicates the customer has given approval for the site design and ordering of equipment"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="approvedDate" [(ngModel)]="site.approvedDate" name="approvedDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.approvedDate" name="approvedDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="hardwareOrderDate">Estimated Hardware Order Date:
                <help-dialog-button fieldName="Estimated Hardware Order Date" helpString="The equipment order should be submitted for processing by this date"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="hardwareOrderDate" [(ngModel)]="site.hardwareOrderDate" name="hardwareOrderDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.hardwareOrderDate" name="hardwareOrderDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="deliveryDate">Estimated Delivery Date:
                <help-dialog-button fieldName="Estimated Delivery Date" helpString="The estimated delivery date by which the equipment order should arrive to the customer site in time for installation"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="deliveryDate" [(ngModel)]="site.deliveryDate" name="deliveryDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.deliveryDate" name="deliveryDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="installDate">Estimated Installation Date:
                <help-dialog-button fieldName="Estimated Installation Date" helpString="The scheduled installation date"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="installDate" [(ngModel)]="site.installDate" name="installDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.installDate" name="installDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="submissionDate">Estimated Submission Date:
                <help-dialog-button fieldName="Estimated Submission Date" helpString="The date devices are submitted to the K2 database post installation"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="submissionDate" [(ngModel)]="site.submissionDate" name="submissionDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.submissionDate" name="submissionDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="completionDate">Actual Completion Date:
                <help-dialog-button fieldName="Actual Completion Date" helpString="The actual completion date that all deployment deliverables have been completed for this site"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="completionDate" [(ngModel)]="site.completionDate" name="completionDate" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.completionDate" name="completionDateSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteSowSigned">Site SOW Signed (Estimated):
                <help-dialog-button fieldName="Site SOW Signed (Estimated)" helpString="Site SOW Signed (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteSowSigned" [(ngModel)]="site.estimatedSiteSowSigned" name="estimatedSiteSowSigned" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteSowSigned" name="estimatedSiteSowSignedSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteSowSigned">Site SOW Signed (Actual):
                <help-dialog-button fieldName="Site SOW Signed (Actual)" helpString="Site SOW Signed (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteSowSigned" [(ngModel)]="site.actualSiteSowSigned" name="actualSiteSowSigned" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteSowSigned" name="actualSiteSowSignedSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteDiscovery">Site Discovery (Estimated):
                <help-dialog-button fieldName="Site Discovery (Estimated)" helpString="Site Discovery (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteDiscovery" [(ngModel)]="site.estimatedSiteDiscovery" name="estimatedSiteDiscovery" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteDiscovery" name="estimatedSiteDiscoverySelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteDiscovery">Site Discovery (Actual):
                <help-dialog-button fieldName="Site Discovery (Actual)" helpString="Site Discovery (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteDiscovery" [(ngModel)]="site.actualSiteDiscovery" name="actualSiteDiscovery" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteDiscovery" name="actualSiteDiscoverySelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteDesignApproval">Site Design Approved (Estimated):
                <help-dialog-button fieldName="Site Design Approved (Estimated)" helpString="Site Design Approved (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteDesignApproval" [(ngModel)]="site.estimatedSiteDesignApproval" name="estimatedSiteDesignApproval" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteDesignApproval" name="estimatedSiteDesignApprovalSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteDesignApproval">Site Design Approved (Actual):
                <help-dialog-button fieldName="Site Design Approved (Actual)" helpString="Site Design Approved (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteDesignApproval" [(ngModel)]="site.actualSiteDesignApproval" name="actualSiteDesignApproval" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteDesignApproval" name="actualSiteDesignApprovalSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteMonitoringEnabled">Remote Monitoring Enabled (Estimated):
                <help-dialog-button fieldName="Remote Monitoring Enabled (Estimated)" helpString="Remote Monitoring Enabled (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteMonitoringEnabled" [(ngModel)]="site.estimatedSiteMonitoringEnabled" name="estimatedSiteMonitoringEnabled" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteMonitoringEnabled" name="estimatedSiteMonitoringEnabledSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteMonitoringEnabled">Remote Monitoring Enabled (Actual):
                <help-dialog-button fieldName="Remote Monitoring Enabled (Actual)" helpString="Remote Monitoring Enabled (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteMonitoringEnabled" [(ngModel)]="site.actualSiteMonitoringEnabled" name="actualSiteMonitoringEnabled" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteMonitoringEnabled" name="actualSiteMonitoringEnabledSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteReadyToDeploy">Ready to Deploy (Estimated):
                <help-dialog-button fieldName="Ready to Deploy (Estimated)" helpString="Ready to Deploy (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteReadyToDeploy" [(ngModel)]="site.estimatedSiteReadyToDeploy" name="estimatedSiteReadyToDeploy" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteReadyToDeploy" name="estimatedSiteReadyToDeploySelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteReadyToDeploy">Ready to Deploy (Actual):
                <help-dialog-button fieldName="Ready to Deploy (Actual)" helpString="Ready to Deploy (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteReadyToDeploy" [(ngModel)]="site.actualSiteReadyToDeploy" name="actualSiteReadyToDeploy" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteReadyToDeploy" name="actualSiteReadyToDeploySelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteDeploymentStart">Deployment Start (Estimated):
                <help-dialog-button fieldName="Deployment Start (Estimated)" helpString="Deployment Start (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteDeploymentStart" [(ngModel)]="site.estimatedSiteDeploymentStart" name="estimatedSiteDeploymentStart" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteDeploymentStart" name="estimatedSiteDeploymentStartSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteDeploymentStart">Deployment Start (Actual):
                <help-dialog-button fieldName="Deployment Start (Actual)" helpString="Deployment Start (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteDeploymentStart" [(ngModel)]="site.actualSiteDeploymentStart" name="actualSiteDeploymentStart" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteDeploymentStart" name="actualSiteDeploymentStartSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteDeploymentEnd">Deployment End (Estimated):
                <help-dialog-button fieldName="Deployment End (Estimated)" helpString="Deployment End (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteDeploymentEnd" [(ngModel)]="site.estimatedSiteDeploymentEnd" name="estimatedSiteDeploymentEnd" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteDeploymentEnd" name="estimatedSiteDeploymentEndSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteDeploymentEnd">Deployment End (Actual):
                <help-dialog-button fieldName="Deployment End (Actual)" helpString="Deployment End (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteDeploymentEnd" [(ngModel)]="site.actualSiteDeploymentEnd" name="actualSiteDeploymentEnd" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteDeploymentEnd" name="actualSiteDeploymentEndSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteCustomerAcceptance">Customer Acceptance (Estimated):
                <help-dialog-button fieldName="Customer Acceptance (Estimated)" helpString="Customer Acceptance (Estimated)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteCustomerAcceptance" [(ngModel)]="site.estimatedSiteCustomerAcceptance" name="estimatedSiteCustomerAcceptance" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteCustomerAcceptance" name="estimatedSiteCustomerAcceptanceSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteCustomerAcceptance">Customer Acceptance (Actual):
                <help-dialog-button fieldName="Customer Acceptance (Actual)" helpString="Customer Acceptance (Actual)"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteCustomerAcceptance" [(ngModel)]="site.actualSiteCustomerAcceptance" name="actualSiteCustomerAcceptance" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteCustomerAcceptance" name="actualSiteCustomerAcceptanceSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="estimatedSiteHandover">Handover Complete (Estiamted):
                <help-dialog-button fieldName="Handover Complete (Estiamted)" helpString="Site Handover Date"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="estimatedSiteHandover" [(ngModel)]="site.estimatedSiteHandover" name="estimatedSiteHandover" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.estimatedSiteHandover" name="estimatedSiteHandoverSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
            <div class="inline-block">
              <label for="actualSiteHandover">Handover Complete (Actual):
                <help-dialog-button fieldName="Handover Complete (Actual)" helpString="Site Handover Date"></help-dialog-button>
              </label>
            </div>
            <div class="input-group">
              <input class="form-control" id="actualSiteHandover" [(ngModel)]="site.actualSiteHandover" name="actualSiteHandover" type="text">
              <datepicker class="right input-group-append" [(ngModel)]="site.actualSiteHandover" name="actualSiteHandoverSelector"></datepicker>
            </div>
          </div>
          <div class="form-group col-lg-6">
            <div class="inline-block">
              <label for="sourceName">Source Name:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="sourceName" [(ngModel)]="site.sourceName" name="sourceName" type="text" maxlength="60">
            </div>
          </div>
          <div class="form-group col-lg-6">
            <label for="areaGroup">Area - Group:</label>
            <select class="form-control" id="areaGroup" name="areaGroup" [(ngModel)]="site.defaultAreaGroup">
              <option [ngValue]="null"></option>
              <option *ngFor="let i of groupOptions" [ngValue]="i.id">{{ i.name }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-10">
            <div class="inline-block">
              <label for="sourceDocumentationLink">Source Documentation Link:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="sourceDocumentationLink" [(ngModel)]="site.sourceDocumentationLink" name="sourceDocumentationLink" type="text" maxlength="2000">
            </div>
          </div>
          <div class="form-group col-lg-2 d-flex align-items-end justify-content-end">
            <div class="btn-group">
              <button class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">Purchase Orders<span class="caret"></span></button>
              <ul class="dropdown-menu px-2">
                <ng-template ngFor let-po [ngForOf]="site.partnerPurchaseOrders" let-i="index">
                  <li>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [name]="&quot;poCheck&quot; + i" [(ngModel)]="po.checked" autoLinkToLabel>
                      <label class="form-check-label">{{ po.name }}</label>
                    </div>
                  </li>
                </ng-template>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-10 card-block">
        <h5>Contacts</h5>
        <div class="row ml-4 mr-4 mt-3">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Phone Number</th>
                <th>Email Address</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of contactTypes">
                <tr *ngIf="site[c.field]">
                  <td>{{c.name}}
                    <help-dialog-button class="help-dialog-button-alignment" *ngIf="c.field === 'tonerContact'" fieldName="Toner Contact" helpString="This is the person that receives the consumables"></help-dialog-button>
                    <help-dialog-button class="help-dialog-button-alignment" *ngIf="c.field === 'orderStatusNotification1' || c.field === 'orderStatusNotification2'" fieldName="ASM Contact" helpString="This is the person that receives the order and shipment notification for consumables"></help-dialog-button>
                    <help-dialog-button class="help-dialog-button-alignment" *ngIf="c.field === 'breakfixContact'" fieldName="Breakfix Contact" helpString="This is the person that is contacted for a service call"></help-dialog-button>
                  </td>
                  <td>{{site[c.field].firstName}} {{site[c.field].lastName}}</td>
                  <td>{{site[c.field].phoneNumber}}</td>
                  <td><a [href]="'mailto:' + site[c.field].emailAddress">{{site[c.field].emailAddress}}</a></td>
                  <td>
                    <div class="links"><a href="javascript:void(0)" (click)="editSiteContact(c.field)"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
                  </td>
                </tr>
              </ng-container>
              <tr *ngIf="!hasContacts">
                <td colspan="4">
                  <p class="text-center empty-table-message">There are no contacts to display.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col mb-2 ml-4">
            <div class="btn-group mr-2">
              <button class="btn btn-outline-primary" type="button" (click)="download()"><span class="oi oi-cloud-download"></span> Export Contacts</button>
            </div>
            <div class="btn-group"><a class="btn btn-outline-primary" [uploadFileTo]="'/api/sites/import-contacts?siteId=' + site.id" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" (closed)="importContactsClosed($event)"><span class="oi oi-cloud-upload"></span> Import Contacts</a></div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </form>
</div>